<template>
  <mdb-container fluid>
    <material-card
      title="Schmerzkurve"
      card-icon="pills"
    >
      <template v-slot:actions>
        <mdb-btn
          color="#333"
          class="py-2 px-3 z-depth-0 border border-light rounded"
          @click="modal=!modal"
        >
          <mdb-icon
            color="black"
            icon="plus"
          />
        </mdb-btn>
        <mdb-select
          outline
          class="d-inline-block ml-2"
          wrapperClass="mt-4 mb-0 w-100 ml-2"
          v-model="schmerzkurveOptions"
          label="Schmerzverlauf auswählen"
          @getValue="loadData"
        />
      </template>
      <template v-slot:content>
        <div class="d-flex justify-content-center">
          <mdb-spinner big v-if="loading"/>
        </div>
        <mdb-accordion
          table
          v-if="tableData.length > 0"
        >
          <div
            v-for="(tbl, index) in tableData"
            :key="index"
          >
            <mdb-accordion-pane
              v-if="selectedItem == tbl.Id"
              class="d-flex mb-2"
              title=""
              type="table"
              :isOpen="openPaneNum == index"
              @pane-clicked="handlePaneOpened(index)"
            >
              <mdb-chip
                color="float-right mb-0"
                slot="title"
                class="px-3 ml-3"
              >
                {{ tbl.AenderungVon }}
              </mdb-chip>

              <span class="mt-1 ml-3 float-left" slot="title">
                <mdb-icon size="md" icon="info-circle" />
                  Details zu <h6 class="d-inline-flex pr-2 font-weight-bold"> {{ tbl.Ort }} </h6>
                <mdb-badge color="info"> {{ tbl.Seit | dateFormat }} </mdb-badge>
              </span>

              <div class="px-3 pt-4 pb-1">
                <mdb-tbl
                  responsive bordered
                >
                  <mdb-tbl-body>
                    <tr
                      v-for="(t, i) in titleSchmerzkurve"
                      :key="i"
                      :class="tbl[t.id] ? 'd-flex-box' : 'd-none'"
                    >
                      <td>
                        <strong>
                          <mdb-icon :icon="t.icon" />  {{ t.title }}
                        </strong>
                      </td>
                      <td v-if="tbl[t.id] && t.type == 'String'">
                        {{ tbl[t.id] }}
                      </td>
                      <td v-else-if="tbl[t.id] && t.type == 'Date'">
                        {{ tbl[t.id] | dateFormat }}
                      </td>
                      <td v-else-if="t.id && t.type == 'Boolean'">
                        <mdb-icon
                          :icon="tbl[t.id] ? 'check-circle' : 'times-circle'"
                          :class="tbl[t.id] ? 'green-text' : 'red-text'" />
                      </td>
                      <td v-else-if="tbl[t.id] && t.type == 'Star'">
                        <mdb-icon icon="star" class="blue-text " /> {{ tbl[t.id] }}
                      </td>
                      <td v-else> - </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </mdb-accordion-pane>
          </div>
        </mdb-accordion>
        <list-group-item
          v-else
          :title="'Keine Einträge gefunden'"
        />
        <div v-if="selectedItem">
          <mdb-row>
            <mdb-col sm="12">
              <mdb-btn
                color="primary"
                class="float-left ml-0 mt-3"
                @click="modalCourse=!modalCourse"
              >
                Verlauf <mdb-icon icon="plus" />
              </mdb-btn>
            </mdb-col>
          </mdb-row>
          <div
            v-if="verlaufLists.length > 0"
          >
            <mdb-row
              class="mt-2"
              v-for="(verlauf, index) in verlaufLists"
              :key="index">
              <mdb-col sm="4">
                <mdb-list-group>
                  <mdb-list-group-item
                    :active="collapseItem==index"
                    @click.native.prevent="openCollape(index)">
                    {{ verlauf.Datum }}, {{ verlauf.AenderungVon }} <mdb-icon icon="angle-double-right" />
                  </mdb-list-group-item>
                </mdb-list-group>
              </mdb-col>
              <mdb-col sm="8">
                  <mdb-card v-if="collapseItem==index">
                    <mdb-card-body>
                      <mdb-tbl
                        striped
                      >
                        <mdb-tbl-body>
                          <tr
                            v-for="(t, i) in titleVerlauf"
                            :key="i"
                            class="mdb-color grey lighten-3"
                          >
                            <td>
                              <strong>
                                <mdb-icon :icon="t.icon" />  {{ t.title }}
                              </strong>
                            </td>
                            <td v-if="verlauf[t.id] && t.type == 'String'">
                              {{ verlauf[t.id] }}
                            </td>
                            <td v-else-if="verlauf[t.id] && t.type == 'Date'">
                              {{ verlauf[t.id] | dateFormat }}
                            </td>
                            <td v-else-if="verlauf[t.id] && t.type == 'Star'">
                              <mdb-icon icon="star" class="blue-text " /> {{ verlauf[t.id] }}
                            </td>
                            <td v-else> - </td>
                          </tr>
                        </mdb-tbl-body>
                      </mdb-tbl>
                    </mdb-card-body>
                  </mdb-card>
              </mdb-col>
            </mdb-row>
          </div>
          <list-group-item
            v-else
            :title="'Keine Einträge gefunden'"
          />
        </div>
      </template>
    </material-card>
    <add-pain-level-modal
      :modal-state="modal"
      @close="modal=false"
      @save="savePainModal"
    />
    <add-pain-level-course-modal
      :modal-state="modalCourse"
      :schmerzkurve-id="selectedItem"
      @close="modalCourse=false"
      @save="savePainCourseModal"
    />
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbBtn,
  mdbIcon,
  mdbSelect,
  mdbTbl,
  mdbTblBody,
  mdbAccordion,
  mdbAccordionPane,
  mdbBadge,
  mdbChip,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbListGroup,
  mdbListGroupItem,
  mdbSpinner
} from 'mdbvue';
const AddPainLevelModal = () => import('@/components/modals/AddPainLevelModal')
const AddPainLevelCourseModal = () => import('@/components/modals/AddPainLevelCourseModal')
const MaterialCard = () => import('@/components/card/MaterialCard')
const ListGroupItem = () => import('@/components/accordion/ListGroupItem')
import utils from '@/mixins/Utils'

export default {
  name: 'Schmerzkurve',
  mixins: [utils()],
  components: {
    MaterialCard,
    AddPainLevelModal,
    AddPainLevelCourseModal,
    ListGroupItem,
    mdbContainer,
    mdbBtn,
    mdbIcon,
    mdbSelect,
    mdbTbl,
    mdbTblBody,
    mdbAccordion,
    mdbAccordionPane,
    mdbBadge,
    mdbChip,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbListGroup,
    mdbListGroupItem,
    mdbSpinner
  },

  data () {
    return {
      modal: false,
      modalCourse: false,
      collapseItem: null,
      schmerzkurveOptions: [],
      openPaneNum: null,
      titleSchmerzkurve: [
        {
          title: 'Seit',
          id: 'Seit',
          icon: 'calendar-day',
          type: 'Date'
        },
        {
          title: 'Auslöser',
          id: 'Ausloeser',
          icon: 'key',
          type: 'String'
        },
        {
          title: 'Häufigkeit',
          id: 'Haeufigkeit',
          icon: 'hourglass',
          type: 'String'
        },
        {
          title: 'Verstärkung',
          id: 'Verstaerkung',
          icon: 'level-up-alt',
          type: 'String'
        },
        {
          title: 'Verringerung',
          id: 'Verringerung',
          icon: 'level-down-alt',
          type: 'String'
        },
        {
          title: 'Nicht mehr seit',
          id: 'NichtMehrSeit',
          icon: 'thumbs-up',
          type: 'Date'
        },
        {
          title: 'Art Brennend',
          id: 'Art_Brennend',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Art Drückend',
          id: 'Art_Drueckend',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Art Krampfaertig',
          id: 'Art_Krampfaertig',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Art Pulsierend',
          id: 'Art_Pulsierend',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Art Stechend',
          id: 'Art_Stechend',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Art Sonstige',
          id: 'Art_Sonstige',
          icon: '',
          type: 'String'
        },
        {
          title: 'Bedarfmedikation nach AVO',
          id: 'Bedarfmedikation',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Beschwerden Depression',
          id: 'Beschwerden_Depression',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Beschwerden Magen',
          id: 'Beschwerden_Magenbeschwerden',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Beschwerden Schlaflosigkeit',
          id: 'Beschwerden_Schlaflosigkeit',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Beschwerden Übelkeit',
          id: 'Beschwerden_Uebelkeit',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Beschwerden Verstopfung',
          id: 'Beschwerden_Verstopfung',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Beschwerden Sonstige',
          id: 'Beschwerden_Sonstige',
          icon: '',
          type: 'String'
        },
        {
          title: 'Dauermedikation nach AVO',
          id: 'Dauertmedikation',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'KamMitSchmerz',
          id: 'KamMitSchmerz',
          icon: '',
          type: 'Boolean'
        },
        {
          title: 'Intensität',
          id: 'Intensitaet',
          icon: '',
          type: 'Star'
        },
        {
          title: 'Intensität BESD',
          id: 'Intensitaet_BESD',
          icon: '',
          type: 'Star'
        },
        {
          title: 'Maßnahmen',
          id: 'Massnahmen',
          icon: '',
          type: 'String'
        }
      ],
      titleVerlauf: [
        {
          title: 'Intensität',
          id: 'Intensitaet',
          icon: 'bullhorn',
          type: 'Star'
        },
        {
          title: 'Intensität BESD',
          id: 'Intensitaet_BESD',
          icon: 'chart-bar',
          type: 'Star'
        },
        {
          title: 'Kommentar',
          id: 'Kommentar',
          icon: 'comment-dots',
          type: 'String'
        }
      ],
      tableData: [],
      verlaufLists: [],
      selectedItem: 0,
      loading: false
    }
  },

  created() {
    this.loadSchmerzkurve()
  },

  methods: {
    handlePaneOpened(num) {
      if (this.openPaneNum == num) {
        return (this.openPaneNum = null)
      }
      this.openPaneNum = num;
    },

    openCollape(key) {
      if (this.collapseItem == key) {
        return (this.collapseItem = null)
      }
      this.collapseItem = key;
    },

    savePainModal () {
      this.modal = false
      this.loadSchmerzkurve()
    },

    savePainCourseModal () {
      this.modalCourse = false
      this.loadSchmerzkurve()
    },

    loadData(value) {
      if(value) {
        this.selectedItem = value
        let obj = this.tableData.find(key => {
            return key.Id == value
        })
        this.verlaufLists = obj.Verlauf
      }
    },

    loadSchmerzkurve() {
      // defult select option
      let isSelected = false
      let selectValue = this.selectedItem

      this.loading = true
      this.$http.get(`/Schmerzkurve/${this.roomID}`)
        .then(res => {
          if(res.data.data) {
            this.tableData = res.data.data

            //set drop down data
            const filters = this.$options.filters
            let schmerzkurveArray = []

            this.tableData.map(function(value) {
              if(value.Id == selectValue) {
                isSelected = true
              }
              let dt = filters.dateFormat(value.Datum, 'date')
              const element = { 'text': dt +', '+ value.Ort, 'value': value.Id, selected: isSelected}
              schmerzkurveArray.push(element)

              if(value.Verlauf.length > 0) {
                value.Verlauf.map(function(val) {
                  val.Datum = filters.dateFormat(val.Datum)
                })
              }
            })
            this.schmerzkurveOptions = schmerzkurveArray
          }
        })
        .catch((error) => {
          this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.list-group-item.active {
    z-index: 2;
    color: #000;
    background-color: #eeeeee;
    border-color: #bab0b0;
}
</style>
